export const Currency = {
    EURO: '€',
    DOLLAR: '$'
};
